import { router } from "@inertiajs/react";
import { useConfirmDialog } from "@/components/confirm-dialog-provider";
import { ProductShowLayout, ProductShowPage } from "@/pages/products/product-show-view";
import { manage_product_path, manage_product_steps_path, product_step_path, products_path } from "@/routes";

function ShowProduct({ product, onCreateStep = null, onEditStep = null }) {
  return (
    <ProductShowPage
      product={product}
      stepHrefBuilder={(currentProduct, step) => product_step_path(currentProduct.id, step.id)}
      onCreateStep={onCreateStep}
      onEditStep={onEditStep}
    />
  );
}

function ProductShowPageLayout({ page }) {
  const { product } = page.props;
  const { confirm } = useConfirmDialog();

  return (
    <ProductShowLayout
      page={page}
      breadcrumbs={[
        { label: "Produkter", href: products_path() },
        { label: product.name }
      ]}
      updatePath={(currentProduct) => manage_product_path(currentProduct.id)}
      createStepPath={(currentProduct) => manage_product_steps_path(currentProduct.id)}
      editStepPath={(currentProduct, step) => product_step_path(currentProduct.id, step.id)}
      actions={({ product: currentProduct, canEditProduct, openEdit, openCreateStep }) => [
        {
          href: products_path(),
          label: "Tilbage",
          variant: "outline-secondary"
        },
        ...(canEditProduct ? [
          {
            label: "Tilføj trin",
            variant: "outline-primary",
            onClick: openCreateStep
          },
          {
            label: "Redigér",
            variant: "primary",
            onClick: openEdit
          },
          {
            label: "Slet",
            variant: "danger",
            onClick: async () => {
              const confirmed = await confirm({
                title: "Slet produkt",
                description: `Vil du slette "${currentProduct.name}"?`,
                confirmLabel: "Slet",
                confirmVariant: "danger"
              });

              if (!confirmed) return;

              router.delete(manage_product_path(currentProduct.id));
            }
          }
        ] : [])
      ]}
    />
  );
}

ShowProduct.layout = (page) => <ProductShowPageLayout page={page} />;

export default ShowProduct;
